module.exports = __webpack_public_path__ + "static/media/2.57ec2cb7.png";